import PropTypes from 'prop-types';
import React from 'react';
import Button from '../Button/Button';
import styles from './SingleHeroSlider.module.css';

const SingleHeroSlider = ({title, sub, text, link, image,buttonText}) => {
    return (
        <div className={styles.singleSlider}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className={styles.sliderContent}>
                            <article>
                                <h3>{title}</h3>
                                <h4>{sub}</h4>
                                <p>{text}</p>
                                <Button 
                                    text={buttonText}
                                    link={link}
                                />
                            </article>
                            <div className={styles.imgWrapper}>
                                <img src={image} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleHeroSlider;

//type checking 
SingleHeroSlider.propTypes = {
    title: PropTypes.string,
    sub: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.string,
    image: PropTypes.string,
    buttonText: PropTypes.string,
}
